export const aciNight = {
    iconName: 'night',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M19.031 7.079a.703.703 0 00.703-.704c0-1.163.947-2.109 2.11-2.109a.703.703 0 000-1.406c-1.144 0-2.11-.988-2.11-2.156a.703.703 0 00-1.406 0c0 1.168-.966 2.156-2.11 2.156a.703.703 0 100 1.406c1.164 0 2.11.946 2.11 2.11 0 .388.315.703.703.703zm-.715-3.523a3.62 3.62 0 00.715-.726c.206.277.444.52.715.726a3.549 3.549 0 00-.715.713 3.544 3.544 0 00-.715-.713zM14.11 4.968a.703.703 0 00-1.407 0 3.52 3.52 0 01-3.515 3.516.703.703 0 000 1.406 3.52 3.52 0 013.515 3.516.703.703 0 001.406 0 3.52 3.52 0 013.516-3.516.703.703 0 000-1.406 3.52 3.52 0 01-3.516-3.516zm-.704 5.905a4.959 4.959 0 00-1.686-1.686 4.959 4.959 0 001.686-1.686 4.96 4.96 0 001.686 1.686 4.96 4.96 0 00-1.686 1.686z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M12 24c6.03 0 11.195-4.524 11.994-10.373a.703.703 0 00-1.283-.484c-1.548 2.33-4.305 3.779-7.195 3.779-4.653 0-8.438-3.785-8.438-8.438 0-2.89 1.448-5.647 3.78-7.195a.703.703 0 00-.485-1.283C4.517.806 0 5.978 0 12c0 6.607 5.393 12 12 12zM7.886 2.14a10.257 10.257 0 00-2.214 6.344c0 5.428 4.416 9.844 9.844 9.844 2.325 0 4.579-.811 6.344-2.214-1.637 3.832-5.489 6.48-9.86 6.48C6.159 22.594 1.406 17.84 1.406 12c0-4.371 2.648-8.223 6.48-9.86z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
